import { Injectable } from '@angular/core';
import {
  FORMPI_PAYMENT,
  PostProcessor,
  PostProcessorType,
} from '../post-processor';
import { LoggingService } from '../../logging/logic/logging.service';
import { PostProcessorXML } from 'src/app/_model/dyn-form/dyn-form-xml';
import { DynForm } from 'src/app/_model/dyn-form';
import { IMSObject } from 'src/app/_model/ims-object';
import { RemoteActionUpdateObject } from 'src/app/_model/remote-action/remote-action-builder/remote-action-builder';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentFormFieldPostProcessor implements PostProcessor {
  // Public Member
  constructor(
    private logger: LoggingService,
    private servicejobsService: ServicejobsService,
  ) {}
  public readonly name: PostProcessorType = FORMPI_PAYMENT;
  private key = this.name + '_key';

  // Lifecycle
  async postProcess(
    form: DynForm,
    formData: any,
    imsObject: IMSObject,
    postProcessorXml?: PostProcessorXML,
    remoteAction?: RemoteAction,
  ): Promise<RemoteActionUpdateObject[]> {
    this.logger.log(
      this.constructor.name,
      'save paid value on object',
      formData,
      formData?.[this.key],
      formData?.[formData?.[this.key]],
    );

    const paymentsData: any[] = formData?.[formData?.[this.key]] ?? [];
    if (paymentsData.length >= 2) {
      const jobsData = paymentsData.slice(0, -1) ?? [];
      const sumData = paymentsData[paymentsData.length - 1];

      let paidCash = sumData['sumpaidcash'] ?? 0;

      for (const jobData of jobsData) {
        const paidCard = jobData['paidcard'] ?? 0;
        this.logger.log(
          this.constructor.name,
          'update value of jobData',
          jobData,
          paidCash,
          paidCard,
        );
        if (paidCard == 0) {
          this.logger.log(
            this.constructor.name,
            'nothing paid with card update paidcash',
            paidCard,
          );
          const jobId = jobData['jobid'];
          const toPay = jobData['topayamt'];
          const job = this.servicejobsService.getServiceJobById({
            imsId: jobId,
            objRef: 'ims/ServiceJob',
          });

          if (paidCash >= toPay) {
            this.logger.log(
              this.constructor.name,
              'enough cash to pay this job full',
            );
            job.paidAmtCash = toPay;
            paidCash -= toPay;
          } else {
            this.logger.log(
              this.constructor.name,
              'not enough cash to pay this job partially with the remaining',
              paidCash,
            );
            job.paidAmtCash = paidCash;
            paidCash = 0;
          }
          await this.servicejobsService.updateServicejob(job);
        }
      }
    }

    return undefined;
  }
}
